export enum AppRoutes {
    HOME = '/planning',

    //* Auth
    LOGIN = '/login',

    //* Password
    PASSWORD_FORGOT = '/password/forgot',
    PASSWORD_RESET = '/password/reset/:email/:token',

    //* CONTROLES
    CONTROLE_TODAY = '/today',
    CONTROLE_LIST = '/controles',
    CONTROLE_DETAILS = '/controles/details/:id',
    CONTROLE_CREATE = '/controles/create',

    //* POINTAGES
    POINTAGES_LIST = '/pointages',

    //* AFFAIRES
    AFFAIRE_LIST = '/affaires',
    AFFAIRE_CREATE = '/affaires/create',
    AFFAIRE_DETAILS = '/affaires/:id',

    //* CAUSERIES
    CAUSERIE_LIST = '/causeries',
    CAUSERIE_DETAILS = '/causeries/:id',
    CAUSERIE_CREATE = '/causeries/create',

    //* RH
    RH = '/rh',
    RH_FORMATIONS = '/rh#formations',
    RH_ABSENCES = '/rh#absences',
    RH_VISITES_MEDICALES = '/rh#visitesMedicales',

    //* Engins
    ENGIN_LIST = '/engins',
    ENGIN_DETAILS = '/engins/:id',
    ENGIN_CREATE = '/engins/create',

    //* Materiels
    MATERIEL_LIST = '/materiels',
    MATERIEL_DETAILS = '/materiels/:id',
    MATERIEL_CREATE = '/materiels/create',

    //* Vehicules
    VEHICULE_LIST = '/vehicules',
    VEHICULE_DETAILS = '/vehicules/:id',
    VEHICULE_CREATE = '/vehicules/create',

    //* RH > COMPAGNONS
    COMPAGNON_LIST = '/rh#personnel',
    COMPAGNON_DETAILS = '/rh/compagnons/:id',
    COMPAGNON_CREATE = '/rh/compagnons/create',

    //* Clients
    CLIENT_LIST = '/clients',
    CLIENT_DETAILS = '/clients/:id',
    CLIENT_CREATE = '/clients/create',

    //* MESSAGE
    MESSAGE = '/message',

    //* PLANNING
    PLANNING = '/planning',
}
